export const LightStatus = {
  open: 1,
  closed: 2,
};

export enum FlightWayEnum {
  RoundTrip = "roundtrip",
  OneWay = "oneway",
}

export const flightWayOptions = [
  { name: "One way", value: FlightWayEnum.OneWay },
  { name: "Round trip", value: FlightWayEnum.RoundTrip },
];

export const passengerTypeOptions = [
  { name: "1", value: 1 },
  { name: "2", value: 2 },
  { name: "3", value: 3 },
  { name: "4", value: 4 },
  { name: "5", value: 5 },
  { name: "6", value: 6 },
  { name: "7", value: 7 },
  { name: "8", value: 8 },
  { name: "9", value: 9 },
];

export const cabinOptionMap = [
  { name: "Economy & Premium Economy", value: "Economy&Premium Economy" },
  { name: "Business & First", value: "Business&First" },
  { name: "Premium Economy & Business", value: "Premium Economy&Business" },
  { name: "Economy", value: "Economy" },
  { name: "Premium Economy", value: "Premium Economy" },
  { name: "Business", value: "Business" },
  { name: "First", value: "First" },
  { name: "Premium Economy & Business & First", value: "Premium Economy&Business&First" },
  { name: "All Cabins", value: "Economy&Premium Economy&Business&First" },
];

export enum RoundTripTypeEnum {
  Outbound = 1,
  Return = 2,
}

export enum AlertTypeEnum {
  Flight = "flight",
  Panorama = "region",
  Hotel = "hotel",
}

export const supportedMegaPrograms = [
  ["AA", "American Airlines AAdvantage"],
  // ["AC", "Air Canada Aeroplan"],
  ["AM", "Aeromexico Club Premier"],
  ["AS", "Alaska Airlines Mileage Plan"],
  ["AV", "Avianca LifeMiles"],
  ["B6", "JetBlue True Blue"],
  ["CM", "Copa ConnectMiles"],
  // ["G3", "GOL Smiles"],
  ["DL", "Delta SkyMiles"],
  ["EK", "Emirates Skywards"],
  ["EY", "Etihad Guest"],
  // ["F9", "Frontier"],
  // ["IB", "Iberia Avios"],
  ["KL", "Air France/KLM Flying Blue"],
  ["NK", "Spirit"],
  ["QF", "Qantas Frequent Flyer"],
  ["SK", "SAS EuroBonus"],
  ["TP", "TAP Air Portugal Miles&Go"],
  ["TK", "Turkish Miles & Smiles"],
  ["UA", "United MileagePlus"],
  ["VA", "Virgin Australia Velocity"],
  ["VS", "Virgin Atlantic Flying Club"],
];

export const supportedPrograms = supportedMegaPrograms.map((value) => {
  return {
    value: value[0],
    name: value[0],
    fullname: value[1],
  };
});

// Sort by name
export const programsOptions = supportedPrograms.sort((a, b) => {
  return a.name.localeCompare(b.name);
});

export const ListViewType = {
  /** 列表模式 */
  List: 1,
  /** 表格模式 */
  Table: 2,
  /** 网格模式 */
  Grid: 3,
};
